import {
  FileText,
  Search,
  CheckCircle,
  Settings,
  Package,
  Eye,
  XCircle
} from "lucide-react";

// Status configurations
export const STATUS_CONFIG = {
  solicitacao_aberta: { label: "Solicitacao Aberta", color: "bg-blue-100 text-blue-800", icon: FileText },
  em_analise_tecnica: { label: "Em Analise Tecnica", color: "bg-yellow-100 text-yellow-800", icon: Search },
  aprovado_desenvolvimento: { label: "Aprovado p/ Desenvolvimento", color: "bg-purple-100 text-purple-800", icon: CheckCircle },
  em_desenvolvimento: { label: "Em Desenvolvimento", color: "bg-orange-100 text-orange-800", icon: Settings },
  prototipo_concluido: { label: "Prototipo Concluido", color: "bg-cyan-100 text-cyan-800", icon: Package },
  em_validacao: { label: "Em Validacao", color: "bg-indigo-100 text-indigo-800", icon: Eye },
  liberado_producao: { label: "Liberado p/ Producao", color: "bg-green-100 text-green-800", icon: CheckCircle },
  cancelado: { label: "Cancelado", color: "bg-red-100 text-red-800", icon: XCircle },
  arquivado: { label: "Arquivado", color: "bg-gray-100 text-gray-800", icon: FileText },
};

export const PRIORITY_CONFIG = {
  baixa: { label: "Baixa", color: "bg-slate-100 text-slate-700" },
  media: { label: "Media", color: "bg-blue-100 text-blue-700" },
  alta: { label: "Alta", color: "bg-orange-100 text-orange-700" },
  estrategica: { label: "Estrategica", color: "bg-red-100 text-red-700" },
};

export const TYPE_CONFIG = {
  novo_produto: { label: "Novo Produto" },
  customizacao: { label: "Customizacao" },
  reducao_custo: { label: "Reducao de Custo" },
  melhoria_tecnica: { label: "Melhoria Tecnica" },
};
